import dynamic from 'next/dynamic';
import ReactDOMServer from 'react-dom/server';

import ShoppingLink from '../components/ShoppingLink/ShoppingLink';
const Quiz = dynamic(() => import('../components/Quiz/Quiz.jsx'));
const AdZone = dynamic(() => import('../components/AdZone/AdZone.jsx'));
const Button = dynamic(() => import('../components/Button/Button.jsx'));
const ItemList = dynamic(() => import('../components/ItemList/ItemList.jsx'));
const SuperLink = dynamic(
  () => import('../components/SuperLink/SuperLink.jsx')
);
const CheckList = dynamic(
  () => import('../components/Checklist/Checklist.jsx')
);
const BlockLink = dynamic(
  () => import('../components/BlockLink/BlockLink.jsx')
);
const GroupList = dynamic(
  () => import('../components/redesign/GroupList/GroupList')
);
const CourseWidget = dynamic(
  () => import('../components/CourseWidget/CourseWidget')
);
const CourseVideo = dynamic(
  () => import('../components/CourseVideo/CourseVideo.jsx')
);
const OrderedList = dynamic(
  () => import('../components/ContentList/ContentList.jsx')
);
const CourseList = dynamic(
  () => import('../components/redesign/CourseList/CourseList')
);
const UnorderedList = dynamic(
  () => import('../components/ContentList/ContentList.jsx')
);
const EbookList = dynamic(
  () => import('../components/redesign/EbookList/EbookList.jsx')
);
const ContentList = dynamic(
  () => import('../components/redesign/ContentGrid/ContentGrid')
);
const FormWidget = dynamic(
  () => import('../components/redesign/FormWidget/FormWidget.jsx')
);
const PregnancyWeek = dynamic(
  () => import('../components/PregnancyWeek/PregnancyWeek.jsx')
);
const InsuranceOffer = dynamic(
  () => import('../components/InsuranceOffer/InsuranceOffer.jsx')
);
const ProductList = dynamic(
  () => import('../components/redesign/ProductList/ProductList.jsx')
);
const ProductCategoryCarousel = dynamic(
  () => import('../components/ProductList/ProductList.jsx')
);
const ContentPartner = dynamic(
  () => import('../components/redesign/ContentPartner/ContentPartner.jsx')
);

const blockComponents = {
  Quiz,
  AdZone,
  Button,
  ItemList,
  BlockLink,
  SuperLink,
  CheckList,
  EbookList,
  GroupList,
  FormWidget,
  CourseList,
  ProductList,
  OrderedList,
  CourseVideo,
  ContentList,
  CourseWidget,
  UnorderedList,
  PregnancyWeek,
  InsuranceOffer,
  ContentPartner,
  ProductCategoryCarousel
};

const inlineComponents = { ShoppingLink };

export default function parseContentHTML(html) {
  return html
    ? html
        .replace(
          /(<|&lt;)[A-Z]{1}[\s\S]+?\/(>|&gt;)/g,
          (str) => `<Separator>${str}<Separator>`
        )

        .split('<Separator>')

        .map((block) => {
          const isComponent = block.match(
            /(<|&lt;)[A-Z]{1}[\s\S]+?\/(>|&gt;)/g
          );

          const components = { ...blockComponents, ...inlineComponents };

          if (isComponent) {
            const component = Object.keys(components).find((key) =>
              block.includes(key)
            );

            const componentName = block.match(/[A-Z]{1}\S+/);

            if (!components[component])
              return { html: `<p>Unknown element: ${componentName}</p>` };

            const args = parseArguments(block) || {};

            if (blockComponents[component])
              return { component: blockComponents[component], args };

            const InlineComponent = inlineComponents[component];

            if (InlineComponent)
              return {
                html: ReactDOMServer.renderToString(
                  <InlineComponent {...args} />
                )
              };
          }

          return { html: block.trim() };
        })
        .reduce((blocks, block) => {
          const lastItem = blocks[blocks.length - 1];

          if (lastItem && lastItem.html && block.html)
            lastItem.html += block.html;
          else blocks.push(block);

          return blocks;
        }, [])
    : [];
}

function parseArguments(component) {
  return component.match(/\s?\w+=("|&quot;).+?\1\s/g)?.reduce((args, str) => {
    const separator = str.search(/=/);

    const key = str.slice(0, separator);
    const value = str.slice(separator + 1);

    const isJSON = /^("|&quot;){.+?}\1$/.test(value.trim());

    if (isJSON)
      try {
        args[key.trim()] = JSON.parse(
          value
            .replace(/&quot;/g, '"')
            .replaceAll(/<a\s*(.*)\>(.*)<\/a>/g, (val) =>
              val.replaceAll('"', '\\"')
            )
            .trim()
            .slice(1, -1)
        );
      } catch (e) {}
    else args[key.trim()] = value.replace(/("|&quot;)/g, '').trim();

    return args;
  }, {});
}

export function extractUrlFromAnchorTag(str) {
  const directUrlRegex = /^https?:\/\/[^\s]+$/;
  if (directUrlRegex.test(str)) return str;

  const anchorTagRegex = /<a\s+href=["']?(https?:\/\/[^\s"'>]+)["']?.*?>/;
  const match = str?.match(anchorTagRegex);

  return match && match[1];
}
